import { motion } from "framer-motion";

export const PilotIntroduction = () => (
  <section data-testid="pilot-introduction-section" className="bg-baseLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-16"
      >
        <div className="lg:col-span-5">
          <h2
            data-testid="pilot-introduction-headline"
            className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
          >
            A real site. A practical energy challenge
          </h2>
        </div>
        <div data-testid="pilot-introduction-text" className="space-y-4 text-[15px] leading-relaxed text-inkSoft lg:col-span-7 lg:pt-1">
          <p>
            Every farm has a different energy profile. An early demonstration project explores
            how renewable generation, battery buffering and long-duration hydrogen storage
            could be configured around the needs of a working farm.
          </p>
          <p>
            We are interested in understanding real operating conditions — from electricity
            demand<br className="hidden lg:block" /> and diesel use to outage exposure and future expansion plans.
          </p>
        </div>
      </motion.div>

      <div className="mt-10 border-t border-borderLight lg:mt-12" />
    </div>
  </section>
);
